import React, { FC } from "react";
import { useParams } from "react-router-dom";

import MainAsideMenuLayout from "../../../../components/layouts/mainAsideMenuLayout/MainAsideMenuLayout";
import HeaderDashboardLayout from "../../../../components/layouts/headerDashboardLayout/HeaderDashboardLayout";
import ItemList from "../../../../components/elements/itemList/ItemList";
import CropsColumnDashboard from "./column";
import CropsRotationDashboard
    from "./rotation";
import List from "../../../../components/elements/list/List";

import { Rotate } from "../../../../types/baseType";
import Tx from "../../../../types/naming";

import st from "./styles.module.scss";
import { withLayout } from "../../DashboardPage";

interface CropsDetailedPageProps {
    children: any;
}

const CropsDetailedPage: FC<CropsDetailedPageProps> = ({ children }) => {

    const { baseCropId = "all" } = useParams<any>();

    return (
            <HeaderDashboardLayout title={Tx.Culture}>
                <List className={st.list} rotate={Rotate.Column}>
                    <ItemList className={st.listItem}>
                        <CropsColumnDashboard/>
                    </ItemList>
                    <ItemList className={st.listItem}>
                        <CropsRotationDashboard/>
                    </ItemList>
                </List>
            </HeaderDashboardLayout>
    );
};

export default withLayout(CropsDetailedPage);
